export enum CatalogActionType {
  FETCH_CATEGORIES = 'FETCH_CATEGORIES',
  FETCH_PRODUCTS = 'FETCH_PRODUCTS',
  FETCH_PRODUCTS_SEARCH = 'FETCH_PRODUCTS_SEARCH',
  FETCH_MORE_PRODUCTS = 'FETCH_MORE_PRODUCTS',
  FETCH_FAVORITES = 'FETCH_FAVORITES',
  FETCH_RECOMMENDED_PRODUCTS = 'FETCH_RECOMMENDED_PRODUCTS',
  FETCH_PRODUCT = 'FETCH_PRODUCT',
  FETCH_WISHLIST = 'FETCH_WISHLIST',
  FETCH_ADD_TO_WISHLIST = 'FETCH_ADD_TO_WISHLIST',
  FETCH_REMOVE_FROM_WISHLIST = 'FETCH_REMOVE_FROM_WISHLIST',
  FETCH_SHIP_TO = 'FETCH_SHIP_TO',
  FETCH_PRODUCTS_AGGREGATIONS = 'FETCH_PRODUCTS_AGGREGATIONS',
  FETCH_PRODUCT_WISHLIST = 'FETCH_PRODUCT_WISHLIST',
  FETCH_SHIP_TO_ADDRESS = 'FETCH_SHIP_TO_ADDRESS',
}
